import { Component, Input, inject } from "@angular/core";
import Moment from "moment";

import { BearingDetailComponent } from "./bearing-detail/bearing-detail.component";
import { GearDetailComponent } from "./gear-detail/gear-detail.component";
import { RawSelectComponent } from "./raw-select/raw-select.component";
import { SensorDetailComponent } from "./sensor-detail/sensor-detail.component";
import { ShaftDetailComponent } from "./shaft-detail/shaft-detail.component";
import { TachDetailComponent } from "./tach-detail/tach-detail.component";
import { ApiService } from "src/app/api.service";
import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-component-detail",
	templateUrl: "./component-detail.component.html",
	styleUrls: ["./component-detail.component.scss"],
	imports: [RawSelectComponent, TachDetailComponent, ShaftDetailComponent, GearDetailComponent, BearingDetailComponent, SensorDetailComponent]
})
export class ComponentDetailComponent {
	private api = inject(ApiService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	component: AssemblyConfig.Component;
	@Input()
	shaft: AssemblyConfig.Shaft;

	public selectedraw: APIResults.RawSinglesResult | APIResults.RawPairsResult;

	rawSelected(raw: APIResults.RawSinglesResult | APIResults.RawPairsResult) {
		if (this.selectedraw !== raw) {
			this.selectedraw = raw;
		}
	}

	DownloadRaw(format: string, extension: string) {
		// this.api.ExportStates(this.asset.asset_name + "_" + this.selectedOperation.start_time.format("YYYY-MM-DD HHmmss") + "_STATES.csv", this.asset.asset_id, this.selectedOperation.operation_id);
		const ts = Moment(this.selectedraw.ts);
		let rawid;
		if ("rawid" in this.selectedraw) {
			rawid = this.selectedraw.rawid;
		} else {
			rawid = this.selectedraw.viberawid;
		}
		this.api.ExportRaw(this.asset.asset_name + "_" + this.component.id + "_" + ts.format("YYYY-MM-DD HHmmss") + "." + extension, this.asset.asset_id, rawid, format);
	}

}
